import { customAlphabet } from 'nanoid';

// Define alphabet and length for the random part of the ID
const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
const generateReportId = customAlphabet(alphabet, 6); // 6-character random string

export const generateAccomplishmentReportId = () => {
    const prefix = 'AR'; // Accomplishment Report prefix
    const timestamp = new Date().toISOString().slice(0, 10).replace(/-/g, ''); // YYYYMMDD format
    const randomPart = generateReportId();
    return `${prefix}-${timestamp}-${randomPart}`;
};
